import { render, staticRenderFns } from "./brightTag.vue?vue&type=template&id=437b3ecb&scoped=true"
import script from "./brightTag.vue?vue&type=script&lang=js"
export * from "./brightTag.vue?vue&type=script&lang=js"
import style0 from "./brightTag.vue?vue&type=style&index=0&id=437b3ecb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437b3ecb",
  null
  
)

export default component.exports